import React, { useEffect } from 'react';
import './Contactus.css';

import LoginBg from '../../assets/images/LoginBg.jpg';
import ContactUsMap from '../../assets/images/ContactUsMap.jpg';
import { Link } from 'react-router-dom';

const Contactus = () => {


  return (
    <>
      <section className='AllpageheaderSection'>
        <div className='AllpageheaderSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 col-sm-12 col-xs-12'>
              <h6><Link to='/'><i className='fas fa-home'></i> Home</Link> <span className='PageHead'>CONTACT US</span></h6>
            </div>
          </div>
        </div>
      </section>
      <section className='AboutusPageSection ContactUsPageSection'>
        <div className='AboutusPageSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-5 col-sm-5 col-xs-12'>
              <h2>Contact us</h2>
              <h3>Corporate Office</h3>
              <p>
                <span>OIDC Corporate Office,</span>
                Plot No. 35, Somnath, Nani Daman, Daman, 396210
                <span>Email</span>
                admin@oidcltd.com
                <span>Phone</span>
                0260 224 1108
              </p>
            </div>

            <div className='col-md-7 col-sm-7 col-xs-12'>
              <div className='ContactUsMapSection'>
                <img src={ContactUsMap} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contactus;
